function IconsHomeNavbar(props) {
    return (
        <svg width="1em" height="1em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5l5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z"></path></svg>
    )
}


function IconsExploreNavbar(props) {
    return (
        <svg width="1em" height="1em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 32 32" {...props}><path fill="currentColor" d="m7.288 23.292l7.997-7.997l1.414 1.414l-7.997 7.997z"></path><path fill="currentColor" d="M17 30a1 1 0 0 1-.37-.07a1 1 0 0 1-.62-.79l-1-7l2-.28l.75 5.27L21 24.52V17a1 1 0 0 1 .29-.71l4.07-4.07A8.94 8.94 0 0 0 28 5.86V4h-1.86a8.94 8.94 0 0 0-6.36 2.64l-4.07 4.07A1 1 0 0 1 15 11H7.48l-2.61 3.26l5.27.75l-.28 2l-7-1a1 1 0 0 1-.79-.62a1 1 0 0 1 .15-1l4-5A1 1 0 0 1 7 9h7.59l3.77-3.78A10.92 10.92 0 0 1 26.14 2H28a2 2 0 0 1 2 2v1.86a10.92 10.92 0 0 1-3.22 7.78L23 17.41V25a1 1 0 0 1-.38.78l-5 4A1 1 0 0 1 17 30Z"></path></svg>
    )
}


function IconsBookmark(props) {
    return (
        <svg width="1em" height="1em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"></path></svg>
    )
}


function IconsProfile(props) {
    return (
        <svg width="1em" height="1em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 16 16" {...props}><g fill="currentColor"><path d="M11 6a3 3 0 1 1-6 0a3 3 0 0 1 6 0z"></path><path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"></path></g></svg>
    )
}


function IconImageInput(props) {
    return (
        <svg width="1.5em" height="1.5em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 16 16" {...props}><g fill="currentColor"><path d="M6.002 5.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0z"></path><path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71l-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"></path></g></svg>
    )
}


function IconEmojiInput(props) {
    return (
        <svg width="1.5em" height="1.5em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 16 16" {...props}><g fill="currentColor"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M12.331 9.5a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zM7 6.5c0 .828-.448 0-1 0s-1 .828-1 0S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 0-1 0s-1 .828-1 0S9.448 5 10 5s1 .672 1 1.5z"></path></g></svg>
    )
}


function IconGifInput(props) {
    return (
        <svg width="1.5em" height="1.5em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 32 32" {...props}><path fill="currentColor" d="M2 12v8a3 3 0 0 0 3 3h5v-8H6v2h2v4H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h5V9H5a3 3 0 0 0-3 3zm28-1V9h-8v14h2v-6h5v-2h-5v-4h6zM12 9v2h3v10h-3v2h8v-2h-3V11h3V9h-8z"></path></svg>
    )
}


function IconHeart(props) {
    return (
        <svg width="1.1em" height="1.1em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="m8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385c.92 1.815 2.834 3.989 6.286 6.357c3.452-2.368 5.365-4.542 6.286-6.357c.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"></path></svg>
    )
}


function IconComment(props) {
    return (
        <svg width="1.3em" height="1.3em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M12 23a1 1 0 0 1-1-1v-3H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4.1l-3.7 3.71c-.2.19-.45.29-.7.29H12m1-6v3.08L16.08 17H21V7H7v10h6M3 15H1V3a2 2 0 0 1 2-2h16v2H3v12Z"></path></svg>
    )
}

function IconShare(props) {
    return (
        <svg width="1.3em" height="1.3em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81c1.66 0 3-1.34 3-3s-1.34-3-3-3s-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65c0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1z"></path></svg>
    )
}

function IconsBookmarkFill(props) {
    return (
        <svg width="1.1em" height="1.1em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"></path></svg>
    )
}


function IconHeartFill(props) {
    return (
        <svg width="1em" height="1em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15C-7.534 4.736 3.562-3.248 8 1.314z"></path></svg>
    )
}


function IconPlus(props) {
    return (
        <svg width="1.2em" height="1.2em" fontWeight="700" cursor="pointer" color="var(--icon-color)" fontSize="1.2em" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path></svg>
    )
}


function IconThreeDots(props) {
    return (
        <svg width="1em" height="1em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M3 9.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3z"></path></svg>
    )
}


function IconArrowBack(props) {
    return (
        <svg width="1.5em" height="1.5em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m12 20l-8-8l8-8l1.425 1.4l-5.6 5.6H20v2H7.825l5.6 5.6Z"></path></svg>
    )
}



function IconClose(props) {
    return (
        <svg width="1em" height="1em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 16 16" {...props}><g fill="currentColor"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8L4.646 5.354a.5.5 0 0 1 0-.708z"></path></g></svg>
    )
}



function IconCalendar(props) {
    return (
        <svg width="1em" height="1em" cursor="pointer" color="var(--icon-color)" viewBox="0 0 16 16" {...props}><g fill="currentColor"><path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"></path><path d="M12 7a1 1 0 1 0 0-2a1 1 0 0 0 0 2zm-5 3a1 1 0 1 0 0-2a1 1 0 0 0 0 2zm2-3a1 1 0 1 0 0-2a1 1 0 0 0 0 2zm-5 3a1 1 0 1 0 0-2a1 1 0 0 0 0 2z"></path></g></svg>
    )
}


function IconGoogle(props) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" cursor="pointer" color="white" {...props}><path fill="currentColor" d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27c3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10c5.35 0 9.25-3.67 9.25-9.09c0-1.15-.15-1.81-.15-1.81Z"></path></svg>
    )
}

export {
    IconsHomeNavbar,
    IconsExploreNavbar,
    IconsBookmark,
    IconsProfile,
    IconImageInput,
    IconEmojiInput,
    IconGifInput,
    IconHeart,
    IconComment,
    IconShare,
    IconsBookmarkFill,
    IconHeartFill,
    IconPlus,
    IconThreeDots,
    IconArrowBack,
    IconClose,
    IconCalendar,
    IconGoogle
}
